<wr-new-data-table headerText="Rollenübersicht"
                   localStorageIdentifier="role-overview"
                   [loadItemsFunction]="loadUsers"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToTenantRole($event)"
                   (newClick)="add()"
                   [form]="form"
                   [isAdmin]="canCreate()">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-items">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-role
    key="name"
    display="Name">
    <div *ngIf="role.name">
      {{ role.name }}
    </div>
  </ng-template>
  <ng-template
    dataColumn
    let-role
    key="description"
    display="Beschreibung">
    <div *ngIf="role.description">
      {{ role.description }}
    </div>
  </ng-template>
  <ng-template
    dataColumn
    let-role
    key="color"
    display="Farbe">
    <div class="color-swatch" [style.background]="role.color"></div>
  </ng-template>
</wr-new-data-table>
